import { redirectWithGet } from '../../../shared/api/redirect/redirect.js';
import { redirectCommonPwd } from '../../../changePwd/src/form/redirectCommonPwd.js';
import { isSamlAccess } from '../../../shared/DOM/isSamlAccess.js';
import { ACCOUNTS_END_STEP } from '../steps/enrollment-steps.constant.js';

export function showMessageFinish(user, domain, group, stepNum) {
  if (isSamlAccess()) {
    redirectToExit();
  } else {
    edicom.notif.prompt({
      label: edicom.locale.translate('enrollment.finish_ok'),
      content: getMessageContent(stepNum),
      accept: () => {
        redirectToLogin(user, domain, group);
      },
      noCancel: true,
    });
  }
}

function getMessageContent(stepNum) {
  return `${stepNum}` === ACCOUNTS_END_STEP ? edicom.locale.translate('enrollment.accounts.finish') : edicom.locale.translate('enrollment.login_error');
}

function redirectToExit() {
  redirectWithGet('/alert/exit/?icon=circle-checkt&title=enrollment.finish_ok&message=enrollment.login_error');
}

function redirectToLogin(user, domain, group) {
  // Es de changePwd pero está relacionado
  redirectCommonPwd({ user, domain, group, custom: true });
}
